import { FC } from "react";
import "./App.less";

import { BrowserRouter as Router } from "react-router-dom";
import { UserStateProvider } from "./common/UserContext";
import { AppNavProvider } from "./common/AppNavContext";
import { AppRoutes } from "./AppRoutes";

/**
 *
 * TODO: OPTIMIZE ROUTE RENDERING
 */
const App: FC = () => (
    <Router>
        <UserStateProvider>
            <AppNavProvider>
                <AppRoutes />
            </AppNavProvider>
        </UserStateProvider>
    </Router>
);

export default App;
